import * as React from 'react';

var _path, _path2, _mask, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLockIconUpdated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 60,
    viewBox: "0 0 52 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.429 26.75H44.57c3.753 0 6.679 2.77 6.679 6.05v20.4c0 3.28-2.926 6.05-6.679 6.05H7.43C3.676 59.25.75 56.48.75 53.2V32.8c0-3.28 2.926-6.05 6.679-6.05z",
    stroke: "#646E8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 41a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM26 44v3",
    stroke: "#646E8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "lock-icon-updated_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 26V13c0-3.448 1.528-6.754 4.247-9.192C17.967 1.37 21.654 0 25.5 0s7.534 1.37 10.253 3.808C38.473 6.246 40 9.552 40 13v13"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 26a1.5 1.5 0 003 0h-3zm16-26v-1.5V0zM40 13h1.5H40zm-1.5 13a1.5 1.5 0 003 0h-3zm-26 0V13h-3v13h3zm0-13c0-2.994 1.325-5.903 3.748-8.076l-2.002-2.233C11.23 5.394 9.5 9.098 9.5 13h3zm3.748-8.076C18.677 2.747 22.003 1.5 25.5 1.5v-3c-4.194 0-8.244 1.492-11.254 4.19l2.002 2.234zM25.5 1.5c3.497 0 6.823 1.247 9.252 3.424l2.002-2.233C33.744-.008 29.694-1.5 25.5-1.5v3zm9.252 3.424C37.175 7.097 38.5 10.006 38.5 13h3c0-3.902-1.73-7.606-4.746-10.31l-2.002 2.234zM38.5 13v13h3V13h-3z",
    fill: "#646E8A",
    mask: "url(#lock-icon-updated_svg__a)"
  })));
}

export { SvgLockIconUpdated as ReactComponent };
